import { connect } from 'react-redux'
import Suspense from './suspense'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me, meRequest }) => ({
  pending: !me && meRequest.pending
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(Suspense)
)
